import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as DTO from './DTOs';
import * as API from './apisvc';
import * as Session from './Session';
import moment from 'moment';





export function commandFType(type: string, node: React.Component, callback: any) {
    return {
        type: 'ACTION',
        success: false,
        reason: '',
        payload: {}
    }
}

export function bindRetString() {
    return "";
}

export function bindFType(type: string, node: React.Component, callback: any) {
    return;
    //return {
    //    type: "EXAMPLE_ACTION",
    //    payload: some
    //}
}
export function actionFType(type: string, payload: any, node: React.Component, callback: any) {
    return;
    //return {
    //    type: "EXAMPLE_ACTION",
    //    payload: some
    //}
}

export function publishWArgsFType() {
    return;
}

export function publishFType(type: string, payload: any) {
    return;
}

export function authHdrFType(getAuthHdrFn: any) {
    return;
}

export function getterDSFType(getDSFn: any) {
    return;
}

export function getApiUrlFType() {
    return '';
}

export function getAppIdFType() {
    return 0;
}


export function postTextMessageFType(sender: string, message: string, idchat?: number) {
    return;
}

export function removeTextMessageFType(idchat?: number, idmessage?: number) {
    return;
}

export function confirmReadChatFType(idchat?: number, time?: Date) {
    return;
}

export function initContextFType(idapp: number) {

}

export interface Window {
    app_env_tag?: typeof bindRetString;
    tradeflow_binddata?: typeof bindFType;
    tradeflow_unbinddata?: typeof bindFType;
    tradeflow_action?: typeof actionFType;
    tradeflow_command?: typeof commandFType;
    tradeflow_command_unsubscribe?: typeof commandFType;
    tradeflow_publish?: typeof publishFType;
    tradeflow_publishWArgs?: typeof publishWArgsFType;
    tradeflow_authhdr?: typeof authHdrFType;
    tradeflow_getterDS?: typeof getterDSFType;
    tradeflow_getApiUrl?: typeof getApiUrlFType;
    tradeflow_postTextMessage?: typeof postTextMessageFType;
    tradeflow_removeTextMessage?: typeof removeTextMessageFType;
    tradeflow_initContext?: typeof initContextFType;
    tradeflow_confirmReadChat: typeof confirmReadChatFType;
    tradeflow_getAppId?: typeof getAppIdFType;

}

declare var window: Window;

//Button.propTypes = {
//    type: PropTypes.oneOf(Object.keys(TradeflowBindTypes))
//}

export interface TradeCommand<T> {
    type: string;
    payload: T;
}

export interface SystemCommand extends TradeCommand<DTO.CommandReason> {
}

export interface SystemConfigCommand extends TradeCommand<DTO.AppConfig> {

}

export interface ContextCommand extends TradeCommand<DTO.CommandContext> {
}

export interface UserInteractionCommand extends TradeCommand<DTO.UserInteractionContext> {
}

export interface NewOrderFromTemplateCommand extends TradeCommand<DTO.NewNotesOrder> {
}

export interface SelectDoMRecordCommand {
    record?: DTO.DomRecord;
    instrument?: DTO.InstrumentHead
}

export interface SelectChatCommand {
    chat: DTO.ChatState;
}


interface DataHeartBeatDelegation { type: 'SYS.heartbeat', delegate: (data: DTO.SystemHeader) => {} }
interface DataFreshChangesDelegation { type: 'SYS.freshchanges', delegate: (data: DTO.SystemHeader) => {} }
interface SysAvailabilityChangesDelegation { type: 'SYS.updatesysavail', delegate: (data: DTO.SystemOperationAvailabilityDto) => {} }

interface MessageNewOneDelegation { type: 'SYS.MSG.newmessage', delegate: (data: DTO.AgentTextMessage) => {} }
interface TopMessagesDelegation { type: 'SYS.MSG.messages', delegate: (data: DTO.AgentTextMessage[]) => {} }
interface SysUsersDelegation { type: 'SYS.MSG.sysusers', delegate: (data: Session.PersonalState[]) => {} }
interface ChatActivityDelegation { type: 'SYS.MSG.chatactivity', delegate: (data: DTO.AgentChatActivity[]) => {} }
interface MarketQuotesDelegation { type: 'SYS.MSG.marketquotes', delegate: (data: DTO.MarketQuotes) => {} }



interface DataNewAlertDelegation { type: 'DATA.newalert', delegate: (data: DTO.AlertMessage) => {} }
interface DataUpdateInstrumentDelegation { type: 'DATA.updateinstrument', fiid: string, delegate: (data: DTO.Instrument) => {} }
interface DataUpdateMyOrdersDelegation { type: 'DATA.updatemyorders', delegate: (data: DTO.OrderBookRecords) => {} }
interface DataUpdateMyDealsDelegation { type: 'DATA.updatemydeals', delegate: (data: DTO.OrderBookRecords) => {} }


type DataProcessDelegates = DataHeartBeatDelegation | DataFreshChangesDelegation | SysAvailabilityChangesDelegation | MessageNewOneDelegation | TopMessagesDelegation | SysUsersDelegation | ChatActivityDelegation | MarketQuotesDelegation | DataNewAlertDelegation | DataUpdateInstrumentDelegation | DataUpdateMyOrdersDelegation | DataUpdateMyDealsDelegation;


interface CommandSystemDelegation { type: 'COMMAND.system', delegate: (data: SystemCommand) => {} }
interface CommandSystemUpdateConfigDelegation { type: 'COMMAND.SYS.UpdateConfig', delegate: (data: DTO.AppConfig) => {} }
interface CommandSystemForceAgentFrameDelegation { type: 'COMMAND.SYS.forceAgentFrame', delegate: (data: SystemCommand) => {} }
interface CommandSystemForceAgentContextDelegation { type: 'COMMAND.SYS.forceAgentContext', delegate: (data: SystemCommand) => {} }
interface CommandTerminateDelegation { type: 'COMMAND.terminate', delegate: (data: SystemCommand) => {} }
interface CommandLoginRevalidateDelegation { type: 'COMMAND.loginrevalidate', delegate: (data: SystemCommand) => {} }

interface CommandChangeUserDelegation { type: 'COMMAND.changeuser', delegate: (data: ContextCommand) => {} }
interface CommandUserInteractionCtxDelegation { type: 'COMMAND.UI.UserInteractionCtx', delegate: (data: DTO.UserInteractionContext) => {} }
interface CommandStateAgentDSInstrumentFilterDelegation { type: 'COMMAND.State.AgentDSInstrumentFilter', delegate: (data: DTO.AgentDSInstrumentFilter) => {} }
interface CommandStateAgentDSPeriodFilterMyOrdersDelegation { type: 'COMMAND.State.AgentDSPeriodFilterMyOrders', delegate: (data: DTO.AgentDSPeriodFilter) => {} }
interface CommandStateAgentDSAttributeFilterMyOrdersDelegation { type: 'COMMAND.State.AgentDSAttributesFilterMyOrders', delegate: (data: DTO.AgentDSAttributesFilter) => {} }
interface CommandStateAgentDSPeriodFilterMyDealsDelegation { type: 'COMMAND.State.AgentDSPeriodFilterMyDeals', delegate: (data: DTO.AgentDSPeriodFilter) => {} }
interface CommandStateAgentDSAttributesFilterMyDealsDelegation { type: 'COMMAND.State.AgentDSAttributesFilterMyDeals', delegate: (data: DTO.AgentDSAttributesFilter) => {} }


interface CommandStateNewMessagesReadDelegation { type: 'COMMAND.State.NewMessagesRead', delegate: () => {} }


interface CommandNewOrderFromTemplateDelegation { type: 'COMMAND.NewOrderFromTemplate', delegate: (data: DTO.NewNotesOrder) => {} }
interface CommandSelectDoMRecordDelegation { type: 'COMMAND.SelectDoMRecord', delegate: (data: SelectDoMRecordCommand) => {} }
interface CommandSelectChatDelegation { type: 'COMMAND.SelectChat', delegate: (data: SelectChatCommand) => {} }


interface CommandHubStatusDelegation { type: 'HUB.status', delegate: (data: 'disconnected' | 'connected' | 'slow' | 'reconnecting') => {} }


type CommandProcessDelegates = CommandSystemDelegation | CommandSystemUpdateConfigDelegation | CommandTerminateDelegation | CommandLoginRevalidateDelegation | CommandChangeUserDelegation | CommandSystemForceAgentFrameDelegation | CommandSystemForceAgentContextDelegation |
    CommandHubStatusDelegation | CommandUserInteractionCtxDelegation | CommandNewOrderFromTemplateDelegation | CommandSelectDoMRecordDelegation | CommandSelectChatDelegation | CommandStateAgentDSInstrumentFilterDelegation
    | CommandStateAgentDSPeriodFilterMyOrdersDelegation | CommandStateAgentDSAttributeFilterMyOrdersDelegation
    | CommandStateAgentDSPeriodFilterMyDealsDelegation | CommandStateAgentDSAttributesFilterMyDealsDelegation | CommandStateNewMessagesReadDelegation;


export const DataProcessBinding = (node: React.Component, processor: DataProcessDelegates) => {
    if (window.tradeflow_binddata != undefined) {
        switch (processor.type) {
            case 'SYS.heartbeat':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'SYS.freshchanges':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'SYS.updatesysavail':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.newmessage':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.messages':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.chatactivity':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.marketquotes':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.sysusers':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'DATA.newalert':
                return window.tradeflow_binddata(processor.type, node, processor.delegate);
            case 'DATA.updateinstrument':
                return window.tradeflow_binddata('DATA.updateinstrument_' + processor.fiid, node, processor.delegate);
            case 'DATA.updatemyorders':
                return window.tradeflow_binddata('DATA.updatemyorders', node, processor.delegate);
            case 'DATA.updatemydeals':
                return window.tradeflow_binddata('DATA.updatemydeals', node, processor.delegate);
            default:
                const exhaustiveCheck: never = processor;
        }
    }
    return {};
};

export const DataProcessUnBinding = (node: React.Component, processor: DataProcessDelegates) => {
    if (window.tradeflow_unbinddata != undefined) {
        switch (processor.type) {
            case 'SYS.heartbeat':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'SYS.freshchanges':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'SYS.updatesysavail':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.newmessage':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.messages':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.chatactivity':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.marketquotes':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'SYS.MSG.sysusers':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'DATA.newalert':
                return window.tradeflow_unbinddata(processor.type, node, processor.delegate);
            case 'DATA.updateinstrument':
                return window.tradeflow_unbinddata('DATA.updateinstrument_' + processor.fiid, node, processor.delegate);
            case 'DATA.updatemyorders':
                return window.tradeflow_unbinddata('DATA.updatemyorders', node, processor.delegate);
            case 'DATA.updatemydeals':
                return window.tradeflow_unbinddata('DATA.updatemydeals', node, processor.delegate);
            default:
                const exhaustiveCheck: never = processor;
        }
    }
    return {};
};



export const CommandProcessBinding = (node: React.Component, processor: CommandProcessDelegates) => {
    if (window.tradeflow_command != undefined) {
        switch (processor.type) {
            case 'COMMAND.system':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.SYS.UpdateConfig':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.SYS.forceAgentFrame':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.SYS.forceAgentContext':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.terminate':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.loginrevalidate':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.changeuser':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.UI.UserInteractionCtx':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSInstrumentFilter':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSPeriodFilterMyOrders':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSAttributesFilterMyOrders':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSPeriodFilterMyDeals':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSAttributesFilterMyDeals':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.State.NewMessagesRead':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.NewOrderFromTemplate':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.SelectDoMRecord':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'COMMAND.SelectChat':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            case 'HUB.status':
                return window.tradeflow_command(processor.type, node, processor.delegate);
            default:
                const exhaustiveCheck: never = processor;
        }
    }
    return {};
};


export const CommandProcessUnBinding = (node: React.Component, processor: CommandProcessDelegates) => {
    if (window.tradeflow_command_unsubscribe != undefined) {
        switch (processor.type) {
            case 'COMMAND.system':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.SYS.UpdateConfig':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.SYS.forceAgentFrame':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.SYS.forceAgentContext':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.terminate':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.loginrevalidate':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.changeuser':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.UI.UserInteractionCtx':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSInstrumentFilter':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSPeriodFilterMyOrders':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSAttributesFilterMyOrders':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSPeriodFilterMyDeals':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.State.AgentDSAttributesFilterMyDeals':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.State.NewMessagesRead':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.NewOrderFromTemplate':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.SelectDoMRecord':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'COMMAND.SelectChat':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            case 'HUB.status':
                return window.tradeflow_command_unsubscribe(processor.type, node, processor.delegate);
            default:
                const exhaustiveCheck: never = processor;
        }
    }
    return {};
};


export const PostTextMessage = (sender: string, message: string, idchat?: number) => {
    if (window.tradeflow_postTextMessage != undefined) {
        window.tradeflow_postTextMessage(sender, message, idchat);
    }
    return {};

}

export const RemoveTextMessage = (idchat?: number, idmessage?: number) => {
    if (window.tradeflow_removeTextMessage != undefined) {
        window.tradeflow_removeTextMessage(idchat, idmessage);
    }
    return {};

}



export const ConfirmReadChat = (idchat?: number, time?: Date) => {
    if (window.tradeflow_confirmReadChat != undefined) {
        window.tradeflow_confirmReadChat(idchat, time);
    }
    return {};

}


export function PublishCommandWArgs(type: 'COMMAND.SYS.MSG.lastmessages' | 'COMMAND.SYS.MSG.sysusers', ...args: any[]) {
    if (window.tradeflow_publishWArgs != undefined) {
        window.tradeflow_publishWArgs.apply(null, arguments);
    }
    return {};
};


export const PublishCommand = (type: 'COMMAND.SYS.UpdateConfig' | 'COMMAND.SYS.forceAgentFrame' | 'COMMAND.SYS.forceAgentContext' | 'COMMAND.SYS.MSG.topmessages' | 'COMMAND.SYS.MSG.lastmessages' | 'COMMAND.SYS.MSG.sysusers' | 'COMMAND.terminate' | 'COMMAND.changeuser' | 'COMMAND.loginrevalidate' | 'COMMAND.UI.UserInteractionCtx' | 'COMMAND.NewOrderFromTemplate' | 'COMMAND.SelectDoMRecord' | 'COMMAND.SelectChat' | 'COMMAND.State.AgentDSInstrumentFilter' | 'COMMAND.State.AgentDSPeriodFilterMyOrders' | 'COMMAND.State.AgentDSPeriodFilterMyDeals' | 'COMMAND.State.AgentDSAttributesFilterMyOrders' | 'COMMAND.State.AgentDSAttributesFilterMyDeals' | 'COMMAND.State.NewMessagesRead', payload: any) => {

    if (window.tradeflow_publish != undefined) {
        window.tradeflow_publish(type, payload);
    }
    return {};
};

const _PublishCommandIntl = (type: string, payload: any) => {
    if (window.tradeflow_publish != undefined) {
        window.tradeflow_publish(type, payload);
    }
    return {};
};


export const PublishCommandForceAgentFrame = () => { PublishCommand('COMMAND.SYS.forceAgentFrame', {}) };
export const PublishCommandForceAgentContext = () => { PublishCommand('COMMAND.SYS.forceAgentContext', {}) };
export const PublishCommandTopMessages = () => { PublishCommand('COMMAND.SYS.MSG.topmessages', {}) };
export const PublishCommandLastMessages = (idchat: number, count: number, idlastmessage: number) => { PublishCommandWArgs('COMMAND.SYS.MSG.lastmessages', idchat, count, idlastmessage) };
export const PublishCommandSysUsers = (idapp: number) => { PublishCommandWArgs('COMMAND.SYS.MSG.sysusers', idapp) };



export const PublishSysCommand = (cmd_type: string) => { _PublishCommandIntl(cmd_type, {}) };

export function registerAuthHeaderExchange() {
    if (window.tradeflow_authhdr != undefined) {
        window.tradeflow_authhdr(() => { return API.authHeader(); });
    }
}

//export type dataSliceGetter = () => DTO.AgentDSContext;


export function registerDataSliceExchange(getDS: () => DTO.AgentDSContext) {
    if (window.tradeflow_getterDS != undefined) {
        window.tradeflow_getterDS(getDS);
    }
}

export function getApiUrl() {
    if (window.tradeflow_getApiUrl != undefined) {
        return window.tradeflow_getApiUrl();
    }
    else {
        return '';
    }
}

export function getEnvTag() {
    if (window.app_env_tag != undefined) {
        return window.app_env_tag();
    }
    else {
        return '';
    }
}


//export function getAppId() {
//    if (window.tradeflow_getAppId != undefined) {
//        return window.tradeflow_getAppId();
//    }
//    else {
//        return 0;
//    }
//}



export class HttpError extends Error {
    public statusCode: number;
    constructor(errorMessage: string, statusCode: number) {
        super(errorMessage);
        this.statusCode = statusCode;
    }
}

export class TimeoutError extends Error {
    constructor(errorMessage: string = "A timeout occurred.") {
        super(errorMessage);
    }
}

//export function hideAllPopovers ()  {
//    $('.popup-marker').each(function () {
//        let el: any = $(this);
//        el.popover('hide');
//    });
//};


export function dateFormat(date: any, fmt: string, utc: boolean) {
    let utcfn = utc ? 'getUTC' : 'get';
    return fmt.replace(/%[YmdHMS]/g, function (m) {
        switch (m) {
            case '%Y': return date[utcfn + 'FullYear'](); // no leading zeros required
            case '%m': m = 1 + date[utcfn + 'Month'](); break;
            case '%d': m = date[utcfn + 'Date'](); break;
            case '%H': m = date[utcfn + 'Hours'](); break;
            case '%M': m = date[utcfn + 'Minutes'](); break;
            case '%S': m = date[utcfn + 'Seconds'](); break;
            default: return m.slice(1); // unknown code, remove %
        }
        // add leading zero if required
        return ('0' + m).slice(-2);
    });
}

export function formatTimeInSessionCtx(title: string, time?: Date, sessionClose?: Date) {
    if (!time)
        return undefined;

    let cdend = moment().utc().endOf('day');
    let validTime = time ? moment(time).utc() : undefined;
    let limitOverSession = validTime ? sessionClose && moment(sessionClose).isBefore(moment(time)) : undefined;
    let outOfDay = validTime ? validTime.isAfter(cdend) : undefined;

    if (!validTime)
        return undefined;


    return title + (limitOverSession ? 'окончания сессии' : outOfDay ? validTime.format('DD.MM.YYYY HH:mm') : validTime.format('HH:mm'));
}

//export function formatMoney = function (n: number, c: any, d: any, t: any) {
//    //var n = this,

//    var    c = isNaN(c = Math.abs(c)) ? 2 : c,
//        d = d == undefined ? "." : d,
//        t = t == undefined ? "," : t,
//        s = n < 0 ? "-" : "",
//        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
//        j = (j = i.length) > 3 ? j % 3 : 0;
//    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
//};